import { Mesh, MeshLambertMaterial } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/team2/SubTopic3/GLB_ProcesoKrea_V2.glb";
import { GUI } from "dat.gui";
import { gsap } from "gsap";
import ObserverEmitter, { EVENTS } from "../../../../../emitter/Observer";

export class ProcesoKrea extends Mesh {
	constructor(camera, loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		this.camera = camera;
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(2, 2, 2);
		this.objectsMaterials = {
			beforeKey: null,
			newKey: null,
			beforeDoor: null,
			newDoor: null,
		};
		this.observerListtneners();
		// this.helpers();
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			// gltf.scene.visible = false;
			this.add(gltf.scene);
			this.Capuchino = gltf.scene.getObjectByName("Capuchino", true);
			this.Americano = gltf.scene.getObjectByName("Americano", true);
			this.Kobalto = gltf.scene.getObjectByName("Kobalto", true);
			this.Garrafon = gltf.scene.getObjectByName("Garrafon", true);
			this.Rollo = gltf.scene.getObjectByName("Rollo", true);
			this.Trapo = gltf.scene.getObjectByName("Trapo", true);
			this.Spray = gltf.scene.getObjectByName("Spray", true);

			this.Puerta_Frontal = gltf.scene.getObjectByName("Puerta_Frontal", true);
			this.Llave = gltf.scene.getObjectByName("Llave", true);

			this.contenedorRojoCompleto = gltf.scene.getObjectByName("contenedor01-Paso2", true);
			this.contenedorRojoVacio = gltf.scene.getObjectByName("contenedor01-Paso1", true);
			this.contenedorAmarrillo1Completo = gltf.scene.getObjectByName("contenedor02-Paso2", true);
			this.contenedorAmarrillo1Vacio = gltf.scene.getObjectByName("contenedor02-Paso1", true);
			this.contenedorAmarrillo2Completo = gltf.scene.getObjectByName("contenedor03-Paso2", true);
			this.contenedorAmarrillo2Vacio = gltf.scene.getObjectByName("contenedor03-Paso1", true);

			this.CodoContenedor01 = gltf.scene.getObjectByName("CodoContenedor01", true);
			this.CodoContenedor02 = gltf.scene.getObjectByName("CodoContenedor02", true);
			this.CodoContenedor03 = gltf.scene.getObjectByName("CodoContenedor03", true);

			this.Cubeta = gltf.scene.getObjectByName("Cubeta", true);
			this.ResiduosCafe = gltf.scene.getObjectByName("ResiduosCafe", true);

			this.K_Contenedor_de_grano = gltf.scene.getObjectByName("K_Contenedor_de_grano", true);
			this.K_BotonSeleccion = gltf.scene.getObjectByName("K_BotonSeleccion", true);
			this.K_Dispensador = gltf.scene.getObjectByName("K_Dispensador", true);
			this.K_Llave = gltf.scene.getObjectByName("K_Llave", true);
			this.K_PantallaDeDatos = gltf.scene.getObjectByName("K_PantallaDeDatos", true);
			this.K_ParillaDeEscurrimiento = gltf.scene.getObjectByName("K_ParillaDeEscurrimiento", true);
			this.K_ParillaPortaVaso = gltf.scene.getObjectByName("K_ParillaPortaVaso", true);
		});
	}

	onvisibleObjects() {
		this.Capuchino.visible = false;
		this.Americano.visible = false;
		this.Kobalto.visible = false;
		this.Garrafon.visible = false;
		this.Rollo.visible = false;
		this.Trapo.visible = false;
		this.Spray.visible = false;

		// this.Puerta_Frontal.visible = false;
		this.Llave.visible = false;
		this.Llave.position.set(0, 0.6794, 0.055);

		// this.contenedorRojoCompleto.visible = false;
		this.contenedorRojoVacio.visible = false;
		this.contenedorAmarrillo1Completo.visible = false;
		// this.contenedorAmarrillo1Vacio.visible = false;
		this.contenedorAmarrillo2Completo.visible = false;
		// this.contenedorAmarrillo2Vacio.visible = false;

		// this.CodoContenedor01.visible = false;
		// this.CodoContenedor02.visible = false;
		// this.CodoContenedor03.visible = false;

		this.Cubeta.visible = false;
		this.ResiduosCafe.visible = false;

		this.K_Contenedor_de_grano.visible = false;
		this.K_BotonSeleccion.visible = false;
		this.K_Dispensador.visible = false;
		this.K_Llave.visible = false;
		this.K_PantallaDeDatos.visible = false;
		this.K_ParillaDeEscurrimiento.visible = false;
		this.K_ParillaPortaVaso.visible = false;

		//* save materials objects
		this.objectsMaterials.beforeKey = this.Llave001;
		let objectKey = this.Llave;
		const newMaterialKey = objectKey.material.clone();
		newMaterialKey.opacity = 1;
		newMaterialKey.transparent = true;
		newMaterialKey.emissiveIntensity = 1;
		this.objectsMaterials.newKey = newMaterialKey;
		this.objectsMaterials.beforeDoor = this.Puerta_Frontal;
		let objectPuertaFrontal = this.Puerta_Frontal;
		const newMaterialPuertaFrontal = objectPuertaFrontal.material.clone();
		newMaterialPuertaFrontal.opacity = 1;
		newMaterialPuertaFrontal.transparent = true;
		newMaterialPuertaFrontal.emissiveIntensity = 1;
		this.objectsMaterials.newDoor = newMaterialPuertaFrontal;

		const materialBlack = new MeshLambertMaterial({ color: 0x000000 });
		materialBlack.opacity = 1;
		materialBlack.transparent = true;
		materialBlack.emissiveIntensity = 1;
		materialBlack.emissive.set("#404040");
		this.contenedorRojoVacio.material = materialBlack;

		// this.helpersChild();
	}

	onELiminationAnimation() {
		if (this.animation) {
			this.animation.kill();
		}
	}

	onEliminateScene() {
		if (this.animation) {
			this.animation.kill();
		}
		this.visible = false;
	}

	observerListtneners() {
		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFour.tooltipMachineKrea.K_Contenedor_de_grano, () => {
			this.K_Contenedor_de_grano.visible = true;
			this.K_Contenedor_de_grano.position.set(17.9375, 35.582, -70.2852);
		});
		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFour.tooltipMachineKrea.K_BotonSeleccion, () => {
			this.K_PantallaDeDatos.visible = false;
			this.K_BotonSeleccion.visible = true;
			this.K_BotonSeleccion.position.set(9.1152, -21.7627, -39.4073);
		});
		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFour.tooltipMachineKrea.K_Dispensador, () => {
			this.K_BotonSeleccion.visible = false;
			this.K_Dispensador.visible = true;
			this.K_Dispensador.position.set(9.1152, -21.7627, -30.585);
		});
		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFour.tooltipMachineKrea.K_Llave, () => {
			this.K_Contenedor_de_grano.visible = false;
			this.K_Llave.visible = true;
			this.K_Llave.position.set(17.9375, -17.3516, -70.2852);
		});
		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFour.tooltipMachineKrea.K_PantallaDeDatos, () => {
			this.K_Llave.visible = false;
			this.K_PantallaDeDatos.visible = true;
			this.K_PantallaDeDatos.position.set(9.1152, -26.1739, -52.6406);
		});
		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFour.tooltipMachineKrea.K_ParillaDeEscurrimiento, () => {
			this.K_Dispensador.visible = false;
			this.K_ParillaDeEscurrimiento.visible = true;
			this.K_ParillaDeEscurrimiento.position.set(9.1152, -21.7627, -17.3516);
		});
		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFour.tooltipMachineKrea.K_ParillaPortaVaso, () => {
			this.K_ParillaDeEscurrimiento.visible = false;
			this.K_ParillaPortaVaso.visible = true;
			this.K_ParillaPortaVaso.position.set(9.1152, -21.7627, -8.5293);
		});
		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFour.tooltipMachineKrea.finishTooltipMachineKrea, () => {
			this.K_ParillaDeEscurrimiento.visible = false;
			this.K_ParillaPortaVaso.visible = false;
			this.K_Contenedor_de_grano.visible = false;
			this.K_PantallaDeDatos.visible = false;
			this.K_BotonSeleccion.visible = false;
			this.K_Contenedor_de_grano.visible = false;
			this.K_Llave.visible = false;
			this.K_Dispensador.visible = false;

			this.K_ParillaDeEscurrimiento.position.set(0, 0, 0);
			this.K_ParillaPortaVaso.position.set(0, 0, 0);
			this.K_Contenedor_de_grano.position.set(0, 0, 0);
			this.K_PantallaDeDatos.position.set(0, 0, 0);
			this.K_BotonSeleccion.position.set(0, 0, 0);
			this.K_Contenedor_de_grano.position.set(0, 0, 0);
			this.K_Llave.position.set(0, 0, 0);
			this.K_Dispensador.position.set(0, 0, 0);
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFour.visibleGarrafon, () => {
			this.Garrafon.position.set(0, 0.4538, 0.2929);
			this.Garrafon.visible = true;
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFour.hiddenGarrafon, () => {
			this.Garrafon.visible = false;
			this.Garrafon.position.set(0, 0, -2);
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFour.animationLlaveKreaInit, () => {
			this.onAnimateKey();
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFour.animationHiddenContenedor, () => {
			this.contenedorRojoCompleto.visible = false;
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFour.animationSaveContenedorInit, () => {
			this.onAnimationSaveContainerRed();
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFour.animationCloseAnimationInit, () => {
			this.onAnimationCloseDoorMachine();
		});
	}

	onAnimationCloseDoorMachine() {
		this.onELiminationAnimation();

		gsap.to(this.Puerta_Frontal.material, {
			opacity: 1,
			duration: 1,
			onComplete: () => {
				gsap.to(this.Llave.material, {
					opacity: 1,
					duration: 1,
					onComplete: () => {
						gsap.to(this.Llave.rotation, {
							y: 0,
							duration: 1,
							onComplete: () => {
								this.Llave.visible = false;
								this.Llave.position.set(0, 0, 0);
								ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFour.animationCloseAnimationFinish);
							},
						});
					},
				});
			},
		});
	}
	onAnimationSaveContainerRed() {
		this.onELiminationAnimation();
		this.contenedorRojoVacio.visible = true;
		this.animation = gsap.to(this.contenedorRojoVacio.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});

		this.contenedorRojoCompleto.visible = true;
		gsap.to(this.contenedorRojoCompleto.rotation, {
			z: 0,
			duration: 1,
			onComplete: () => {
				this.onELiminationAnimation();
				this.contenedorRojoVacio.visible = false;
				gsap.to(this.contenedorRojoCompleto.position, {
					x: 0.004,
					y: 0.55,
					z: -0.1,
					duration: 1,
					onComplete: () => {
						ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFour.animationSaveContenedorFinish);
					},
				});
			},
		});
	}

	onAnimateKey() {
		let objectKey = this.Llave;
		objectKey.visible = true;
		objectKey.material = this.objectsMaterials.newKey;
		objectKey.material.emissive.set("#404040");
		this.animation = gsap.to(objectKey.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});

		this.Puerta_Frontal.material = this.objectsMaterials.newDoor;

		//* mover
		gsap.to(objectKey.position, {
			y: 0.6627,
			duration: 1,
		});

		gsap.to(objectKey.rotation, {
			x: 1.1174,
			duration: 1,
			onComplete: () => {
				gsap.to(objectKey.rotation, {
					y: -3.1024,
					duration: 1,
					onComplete: () => {
						gsap.to([objectKey.material, this.Puerta_Frontal.material], {
							opacity: 0,
							duration: 1,
							onComplete: () => {
								gsap.to(this.contenedorRojoCompleto.position, {
									x: -0.0788,
									y: 0.5144,
									z: 0.3533,
									duration: 1,
									onComplete: () => {
										gsap.to(this.contenedorRojoCompleto.rotation, {
											z: 0.7918,
											duration: 1,
											onComplete: () => {
												this.onELiminationAnimation();
												objectKey.material.emissive.set("#000000");
												ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFour.animationLlaveKreaFinish);
											},
										});
									},
								});
							},
						});
					},
				});
			},
		});
	}

	onAnimate(object, previousObject) {
		this.onELiminationAnimation();

		//*regresar el color al anterior
		this.beforeColor = object.material.emissive;
		if (previousObject !== undefined) {
			if (this[previousObject] !== undefined) {
				this[previousObject].material.emissive = this.beforeColor;
			}
		}

		const newMaterial = object.material.clone();
		object.material = newMaterial;

		object.material.emissive.set("#404040");

		this.animation = gsap.to(object.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}

	helpers() {
		const gui = new GUI();
		const premiaFolder = gui.addFolder("Krea");
		premiaFolder.add(this.position, "x", -20, 20).step(0.0001).name("Posición X");
		premiaFolder.add(this.position, "y", -20, 20).step(0.0001).name("Posición Y");
		premiaFolder.add(this.position, "z", -20, 20).step(0.0001).name("Posición Z");
		premiaFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		premiaFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		premiaFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
	}

	helpersChild() {
		this.helperMethod("Puerta_Frontal", this.Puerta_Frontal);
	}

	helperMethod(name, object) {
		const { position, rotation } = object;
		const gui = new GUI();
		const folferMostrador = gui.addFolder(name);
		folferMostrador.add(position, "x", -200, 200).step(0.0001).name("Posición X");
		folferMostrador.add(position, "y", -200, 200).step(0.0001).name("Posición Y");
		folferMostrador.add(position, "z", -200, 200).step(0.0001).name("Posición Z");
		folferMostrador.add(rotation, "x", -10, 10).step(0.0001).name("rotation X");
		folferMostrador.add(rotation, "y", -10, 10).step(0.0001).name("rotation Y");
		folferMostrador.add(rotation, "z", -10, 10).step(0.0001).name("rotation Z");
		folferMostrador.add(object, "visible").name("Visible");
	}

	renderAnimations() { }
}
